import { Divider, Group } from '@byecode/ui'
import type { DataSourceAbstract, SubProcessArg } from '@lighthouse/core'
import type { FlowNode, VariableTriggerConfigure } from '@lighthouse/shared'
import { TriggerNodeType } from '@lighthouse/shared'
import { useAtomValue } from 'jotai'
import { find } from 'rambda'
import React, { useMemo } from 'react'

import { workflowListAtom } from '@/atoms/workflow/state'

import * as SC from '../../styles'
import { SettingSubProcessContent } from './SettingSubProcessContent'
import { SubProcessSelector } from './SubProcessSelector'

interface EventSuccessAfterProps {
    title: string
    dataSource: DataSourceAbstract
    prefixNode?: React.ReactNode
    allParentNodes?: FlowNode[]
    value: { workflowId: string; workflowArgs: SubProcessArg[] }
    onChange: (value: { workflowId: string; workflowArgs: SubProcessArg[] }) => void
}

export const EventSuccessAfter: React.FC<EventSuccessAfterProps> = ({ title, dataSource, prefixNode, allParentNodes, value, onChange }) => {
    const workflows = useAtomValue(workflowListAtom)

    const subProcessId = value.workflowId

    // useEffect(() => {
    //     updateWorkflow()
    // }, [updateWorkflow])

    const subProcessArgs = useMemo(() => {
        const workflow = find(item => item.id === subProcessId && item.type === 'subProcess', workflows)
        if (!workflow) {
            return
        }
        const nodeList = workflow.content?.nodes || []
        const variableNode = find(item => item.data.nodeType === TriggerNodeType.ARG_TRIGGER, nodeList)
        if (!variableNode || variableNode.data.nodeType !== TriggerNodeType.ARG_TRIGGER) {
            return
        }
        const { config } = variableNode.data
        if (!config || !config?.args) {
            return
        }
        return config.args
    }, [subProcessId, workflows])

    return (
        <>
            <Group label={title}>
                {prefixNode}
                <SubProcessSelector
                    workflows={workflows}
                    value={value.workflowId}
                    onChange={workflowId => onChange({ workflowId, workflowArgs: [] })}
                />
            </Group>
            {subProcessId && subProcessArgs && subProcessArgs.length > 0 && (
                <>
                    <Divider color="var(--color-gray-200)" />
                    <Group label="子流程参数值设置" defaultOpen>
                        <SC.Tip>设置子流程的参数值，参数值将会传递到子流程中。</SC.Tip>
                        {(() => {
                            const list = value.workflowArgs || []
                            const data =
                                subProcessArgs?.map(item => {
                                    const dataItem = find(d => d.id === item.id, list)
                                    return {
                                        ...item,
                                        value: dataItem?.value
                                    }
                                }) || []
                            return (
                                <SettingSubProcessContent
                                    data={data}
                                    dataSource={dataSource}
                                    allParentNodes={allParentNodes}
                                    onChange={workflowArgs => onChange({ ...value, workflowArgs })}
                                />
                            )
                        })()}
                    </Group>
                </>
            )}
        </>
    )
}
